const selectors = ['DIV', 'SPAN'];

export default function isQuestion(node) {
  return (
    node
    && selectors.includes(node.tagName)
    && node.getAttribute('data-question')
  );
}
